import { get } from "../GenericServices";

const ProjectInvoiceStatement = {
  getDataProgress: (id, queryString) => {
    return get(`project/${id}/income-statement/progress?${queryString}`);
  },
  getDataMonthly: (id, queryString) => {
    return get(`project/${id}/income-statement/monthly?${queryString}`);
  },
};

export default ProjectInvoiceStatement;
